type AmountListItem = {
  label: string;
  value: number;
};

export const amountList: Array<AmountListItem> = [
  { label: '￥200', value: 200 },
  { label: '￥500', value: 500 },
  { label: '￥1000', value: 1000 },
  { label: '￥2000', value: 2000 },
  { label: '￥5000', value: 5000 },
  { label: '￥10000', value: 10000 },
];
